import React from "react";
import { cleanCaption } from "../../hooks/useVideoStudio";

const POS = { top: "top-[7%]", center: "top-1/2 -translate-y-1/2", bottom: "bottom-[8%]" };

// Mirrors the burned-in caption style of the final render: Outfit semibold, 6% of the short side, dark rounded box.
export const CaptionOverlay = ({ captions, t }) => (
  <div className="absolute inset-0 pointer-events-none [container-type:size]" data-testid="caption-overlay">
    {captions.map((c, i) => {
      const text = cleanCaption(c.text);
      const start = Math.max(0, Number(c.start) || 0), end = Number(c.end) || Infinity;
      if (!text || t < start || t > end) return null;
      return (
        <div key={i} data-testid={`caption-live-${i}`} style={{ fontSize: "max(10px, 6cqmin)" }}
          className={`absolute left-1/2 -translate-x-1/2 ${POS[c.position] || POS.bottom} w-max max-w-[86%] text-center text-white font-display font-semibold leading-[1.25] break-words rounded-[0.45em] px-[0.5em] py-[0.3em] bg-slate-900/65`}>
          {text}
        </div>
      );
    })}
  </div>
);

export default CaptionOverlay;
